import apiClient from './_axios';

/**
 * Timed free-time promo (Ray 2026-10-06): "Free 30 min until 6pm".
 * Schedules (Ray 2026-10-23): one day (may start later) / every day / every week.
 */
export interface FreePromo {
   _id: string;
   label: string;
   minutes: number;
   startsAt: string;
   endsAt: string;
   stoppedAt: string | null;
   maxPhones: number | null;
   deviceIds: string[];
   claims: number;
   repeat?: 'once' | 'daily' | 'weekly';
   /** weekly: 0 = Sunday … 6 = Saturday */
   days?: number[];
   /** daily / weekly: PH-time window, minutes of the day */
   windowStart?: number | null;
   windowEnd?: number | null;
   /** When the free window running right now closes (live only). */
   liveUntil?: string | null;
   /** Pesos the promo's phones paid after their free time (live / scheduled only). */
   paidAfter?: number | null;
   status: 'live' | 'scheduled' | 'ended' | 'stopped';
}

/**
 * Which of the owner's routers can already show the promo banner and the
 * announcement on the WiFi page. OpenWrt routers on an older image are
 * "waiting" — the card says "coming very soon" instead of pretending it's up
 * (Ray 2026-10-25, Rhady's 5 Comfast EW71s: "0 phones got it").
 */
export interface RoutersReady {
   ready: number;
   waiting: number;
   waitingNames: string[];
   /** The router update(s) they wait for: '2.6.33' (Ruijie/Comfast/AX) and/or '2.7.10' (OrangePi/mini PC). */
   waitingVersions?: string[];
   /** Ready routers that are MikroTik — live there already. */
   readyMikrotik?: number;
   /** Each waiting main vendo (id = its _id) and the router update it needs — the pickers lock these. */
   waitingList?: { id: string; name: string; version: string }[];
}

export async function listFreePromos(): Promise<{ promos: FreePromo[]; routers: RoutersReady }> {
   const r = await apiClient.get<{ promos: FreePromo[]; routers?: RoutersReady }>('/vendo/free-promos');
   return { promos: r.data.promos, routers: r.data.routers ?? { ready: 0, waiting: 0, waitingNames: [], waitingVersions: [] } };
}

export type CreateFreePromoBody = {
   deviceIds: string[];
   minutes: number;
   maxPhones: number | null;
   label: string;
} & (
   | { repeat: 'once'; startsAt?: string; endsAt: string }
   | {
        repeat: 'daily' | 'weekly';
        windowStart: number;
        windowEnd: number;
        days?: number[];
        /** null = until stopped */
        runDays: number | null;
     }
);

export async function createFreePromo(body: CreateFreePromoBody): Promise<unknown> {
   const r = await apiClient.post('/vendo/free-promos', body);
   return r.data;
}

export async function stopFreePromo(id: string): Promise<unknown> {
   const r = await apiClient.post(`/vendo/free-promos/${id}/stop`);
   return r.data;
}
